import HotWorkCategoryOneOptions from "../../../permits/EnergyHarbourPermit/HotWorkCategoryOneOptions";
import FormElement, { formElement } from "../../FormElement";

type HotWorkCategoryOneOptionsFormState = {
    angleGrinder: FormElement<boolean>;
    cuttingTorch: FormElement<boolean>;
    welding: FormElement<boolean>;
    plasmaCutter: FormElement<boolean>;
    hotAirGun: FormElement<boolean>;
    gasBurner: FormElement<boolean>;
    openFlameSoldering: FormElement<boolean>;
    other: FormElement<string>;
};

export default HotWorkCategoryOneOptionsFormState;

export function HotWorkCategoryOneOptionsFormState_default(): HotWorkCategoryOneOptionsFormState {
    return {
        angleGrinder: formElement(false),
        cuttingTorch: formElement(false),
        gasBurner: formElement(false),
        hotAirGun: formElement(false),
        openFlameSoldering: formElement(false),
        other: formElement(""),
        plasmaCutter: formElement(false),
        welding: formElement(false)
    };
}

export function HotWorkCategoryOneOptionsFormState_fromFormState(
    formState: HotWorkCategoryOneOptionsFormState
): HotWorkCategoryOneOptions {
    return {
        angleGrinder: formState.angleGrinder.value,
        cuttingTorch: formState.cuttingTorch.value,
        welding: formState.welding.value,
        plasmaCutter: formState.plasmaCutter.value,
        hotAirGun: formState.hotAirGun.value,
        gasBurner: formState.gasBurner.value,
        openFlameSoldering: formState.openFlameSoldering.value,
        other: formState.other.value
    };
}
